import {Component, EventEmitter, Input, OnChanges, Output, ViewChild} from '@angular/core';
import {DxPopupComponent} from 'devextreme-angular';

@Component({
  selector: 'app-cancel-dialog',
  templateUrl: './cancel-dialog.component.html',
  styleUrls: ['./cancel-dialog.component.scss']
})
export class CancelDialogComponent implements OnChanges {
  @ViewChild('popupComponent', {static: true}) public popupComponent?: DxPopupComponent;
  public commentTextArea: any;
  public comment = '';
  @Input() public popupVisible = false;
  @Output() public closeEvent = new EventEmitter();
  public username = '';
  public password = '';

  public close() {
    this.closeEvent.emit();
  }

  public clear() {
    this.comment = '';
  }

  public cancel() {
    this.closeEvent.emit({comment: this.comment});
  }

  public ngOnChanges(changes: import('@angular/core').SimpleChanges) {
    if (changes.popupVisible && changes.popupVisible.currentValue) {
      if (this.commentTextArea === undefined) {
        setTimeout(() => {
          this.commentTextArea.instance().focus();
        }, 500);
      } else {
        setTimeout(() => {
          this.commentTextArea.instance().focus();
        }, 500);
      }
    }
  }

  public ready(e: any) {
    this.commentTextArea = e.component;
  }
}
